<template>
<v-menu v-model="visible" :position-x="menuX" :position-y="menuY" absolute offset-y>
  <v-list>
    <v-list-tile avatar @click="$emit('click','control')" v-if="controlable.includes((item||{}).ctrltype)">
      <v-list-tile-avatar>
        <v-icon color="primary">touch_app</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-title>{{ $t('device.control_device') }}</v-list-tile-title>
    </v-list-tile>
    <v-list-tile avatar @click="$emit('click','chart')" v-if="!chartDisable.includes((item || {}).functype)">
      <v-list-tile-avatar>
        <v-icon color="primary">show_chart</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-title>{{ $t('kanban.history') }}</v-list-tile-title>
    </v-list-tile>
    <v-list-tile avatar @click="$emit('click','prediction')" v-if="meter.includes((item||{}).functype)">
      <v-list-tile-avatar>
        <v-icon color="primary">trending_up</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-title>{{ $t('prediction.prediction') }}</v-list-tile-title>
    </v-list-tile>
    <v-list-tile avatar @click="$emit('click','edit')">
      <v-list-tile-avatar>
        <v-icon color="primary">edit</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-title>{{ $t('device.edit') }}</v-list-tile-title>
    </v-list-tile>
  </v-list>
</v-menu>
</template>

<script>
export default {
  name: 'DeviceMenu',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object
    },
    menuX: {
      type: Number,
      default: 0
    },
    menuY: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      controlable: [23, 24, 25, 26, 28, 31, 32, 33, 34, 41],
      chartDisable: [27, 28, 32, 33],
      meter: [22, 29]
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/DeviceMenu.vue